














import { Component, Vue } from "vue-property-decorator";
import Finance from "./Finance.vue";
import Investment from "./Investment.vue";
import Derivative from "./Derivative.vue";

@Component({
  components: {
    finance: Finance,
    investment: Investment,
    derivative: Derivative
  }
})
export default class Login extends Vue {
  page = 1;
}
